module.exports = __webpack_public_path__ + "static/media/iss2.d3956863.png";